import CryptoJS from 'crypto-js'
import SHA256 from 'crypto-js/sha256'

/***
*
* @param data
* @returns {string}
*/
export const strToBase64 = (data) => {
  return CryptoJS.enc.Base64.stringify(data).replace(/\+/g, '-').replace(/\//g, '_').replace(/\n/g, '')
}



/***
 * 生成签名
 * @param appId
 * @param timestamp
 * @param nonce
 * @param httpMethod
 * @param httpURL
 * @returns {*}
 */
export const generateSignature_v2 = (appId, timestamp, nonce, httpMethod, httpURL) => {
  const str = appId + '&' + timestamp + '&' + nonce + '&' + httpMethod + '&' + httpURL
  let result = SHA256(str)
  if (result) {
      result = strToBase64(result)
  }
  return result
}

/***
 * 生成随机字符串
 * @param theServerTime
 * @returns {*}
 */
export const generateNonce = (theServerTime) => {
  const randomNumber = []
  for (let i = 0; i < 8; i++) {
      const oneRandom = random(-128, 127)
      randomNumber.push(oneRandom)
  }
  let timeStamp = Math.floor(new Date().getTime() / 60000)
  if (theServerTime !== 0) {
      timeStamp = Math.floor(theServerTime / 60000)
  }

  const nt = []
  nt[3] = timeStamp & 0xff
  nt[2] = (timeStamp >> 8) & 0xff
  nt[1] = (timeStamp >> 16) & 0xff
  nt[0] = (timeStamp >> 24) & 0xff
  for (let x = 0; x < nt.length; x++) {
      randomNumber.push(nt[x])
  }

  return bytesToBase64_v2(randomNumber)
}

export const bytesToBase64_v2 = (bytes) => {
  var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  for (var base64 = [], i = 0; i < bytes.length; i += 3) {
      var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]
      for (var j = 0; j < 4; j++) {
          if (i * 8 + j * 6 <= bytes.length * 8) { base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F)) } else base64.push('=')
      }
  }

  return base64.join('')
}

/**
 * 获取随机数 -128 -- 127
 */
export const random = (min, max) => {
  return Math.floor(min + ((Math.random() * 255) % (max - min)))
}

export const bytesToBase64 = (bytes) => {
  var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  for (var base64 = [], i = 0; i < bytes.length; i += 3) {
    var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]
    for (var j = 0; j < 4; j++) {
      if (i * 8 + j * 6 <= bytes.length * 8) { base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F)) } else base64.push('=')
    }
  }

  return base64.join('')
}


export function Encrypt(word) {
  let key = CryptoJS.enc.Utf8.parse("e1b339e072f81a88");
  let iv = CryptoJS.enc.Utf8.parse("e1b339e072f81a88");
  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
  });
  var encrypt = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  return encrypt;
}